import { batch } from 'react-redux';
import { ProfileExtent } from '@mews-commander/data-access';
import { AsyncAction, CommanderThunkAction } from '@mews-commander/types';
import { createFetchAction, notEmpty } from '@mews-commander/utils';
import { setCashiers } from '../ducks/cashiers';
import { setCashierAssignments } from '../ducks/cashierAssignments';
import { updateEnterpriseProfilesState } from '../ducks/enterpriseProfiles';
import { setSimpleUsers } from '../ducks/simpleUsers';
import prefix from '../prefix';
import { setDepartments } from '../ducks/departments';
import { setEnterpriseProfileRoleAssignments } from '../ducks/enterpriseProfileRolesAssignments';

const ENTERPRISE_PROFILES_FETCH = prefix('ENTERPRISE_PROFILES_FETCH');
const ENTERPRISE_PROFILES_ADD = prefix('ENTERPRISE_PROFILES_ADD');
const ENTERPRISE_PROFILES_UPDATE = prefix('ENTERPRISE_PROFILES_UPDATE');

const handleEnterpriseProfileResponse =
    ({
        enterpriseId,
        profiles,
        users,
        departments,
        cashiers,
        cashierAssignments,
        roleAssignments,
    }: $TSFixMe): CommanderThunkAction =>
    (dispatch) => {
        batch(() => {
            if (notEmpty(profiles)) {
                dispatch(updateEnterpriseProfilesState(profiles, enterpriseId));
            }
            if (notEmpty(users)) {
                dispatch(setSimpleUsers(users));
            }
            if (notEmpty(departments)) {
                dispatch(setDepartments(departments, enterpriseId));
            }
            if (notEmpty(cashiers)) {
                dispatch(setCashiers(cashiers, enterpriseId));
            }
            if (notEmpty(cashierAssignments)) {
                dispatch(setCashierAssignments(cashierAssignments, enterpriseId));
            }
            if (notEmpty(roleAssignments)) {
                dispatch(setEnterpriseProfileRoleAssignments(roleAssignments, enterpriseId));
            }
        });

        return { enterpriseId, profiles, users, departments, cashiers, cashierAssignments, roleAssignments };
    };

const fetch =
    ({ enterpriseId, ...other }: $TSFixMe): CommanderThunkAction =>
    async (dispatch, getState, { repositories }) => {
        const promise = repositories.enterpriseProfiles
            .getAll({ enterpriseId, ...other })
            .then((response) => dispatch(handleEnterpriseProfileResponse({ enterpriseId, ...response })));

        return dispatch(createFetchAction(ENTERPRISE_PROFILES_FETCH, promise));
    };

export const fetchEnterpriseProfile = ({
    enterpriseProfileId,
    enterpriseId,
    extent: { actors, users, departments, cashierAssignments, cashiers, roleAssignments } = {},
}: {
    enterpriseProfileId: string;
    enterpriseId: string;
    extent: ProfileExtent;
}) =>
    fetch({
        enterpriseProfileIds: [enterpriseProfileId],
        enterpriseId,
        extent: { actors, users, departments, cashierAssignments, cashiers, roleAssignments },
    });

export const addEnterpriseProfile =
    ({ enterpriseId, ...other }: $TSFixMe): CommanderThunkAction =>
    async (dispatch, getState, { repositories }) => {
        const promise = repositories.enterpriseProfiles
            .add({ enterpriseId, ...other })
            .then((response) => dispatch(handleEnterpriseProfileResponse({ enterpriseId, ...response })));

        return dispatch(createFetchAction(ENTERPRISE_PROFILES_ADD, promise));
    };

export const updateEnterpriseProfile =
    ({ enterpriseId, ...other }: $TSFixMe): CommanderThunkAction<AsyncAction> =>
    async (dispatch, getState, { repositories }) => {
        const promise = repositories.enterpriseProfiles
            .update({ enterpriseId, ...other })
            .then((response) => dispatch(handleEnterpriseProfileResponse({ enterpriseId, ...response })));

        return dispatch(createFetchAction(ENTERPRISE_PROFILES_UPDATE, promise));
    };
